import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
    name: 'cms',
    standalone: false
})
export class CmsPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    return `${environment.cmsUrl}/${value}`;
  }
}
